/*******************************************************
 *
 * 使用此JS脚本之前请先仔细阅读mToken KEY帮助文档
 * 
 * @author		Longmai
 * @version		3.0
 * @date		2015/9/25
 * @explanation	 mToken Plugin 支持各浏览器
 *
**********************************************************/
    import {mToken,mTokenPlugin} from './mToken';
    import {_Base64encode, _Base64decode,_utf8_encode,_utf8_decode} from './base64';
    var token = new mToken("mTokenPlugin");
	//动态添加option选项
	function addOption(optionStr, selectID, flag)
	{		
		if(flag == 1)
		{				
			for(var i = 0; i < optionStr.length; ++i)
				selectID.options.add(new Option(optionStr[i], i));
		}
		if(flag == 2)
		{	
			for(var i = 0; i < optionStr.length; ++i)
			{
				selectID.options.add(new Option(optionStr[i][1], i));
			}
		}
	}
	
	//枚举当前设备
	// function enumDevice()
	// {
	//     var errorMsg = "error:";
	// 	var ret = 0;

	// 	ret = token.SOF_LoadLibrary(token.GM3000);
	// 	if(ret != 0)
	// 	{
	// 	    return errorMsg + "加载控件失败";
	// 	}
	// 	var deviceName = token.SOF_EnumDevice();
		
	// 	if(deviceName != null)
	// 	{
	// 	    return deviceName;
	// 	}
	// 	else
	// 	{
	// 	    return errorMsg + "未找到任何key";
	// 	}
	// }
	//枚举当前设备
	function enumDevice()
	{
	    var deviceReturn = [];
		var ret = 0;

		ret = token.SOF_LoadLibrary(token.GM3000);
		if(ret != 0)
		{
			deviceReturn.num = 1002;
			deviceReturn.msg = "加载控件失败";
			return deviceReturn;
		}
		var deviceName = token.SOF_EnumDevice();
		
		if(deviceName != null)
		{
			deviceReturn.num = 1001;
			deviceReturn.msg = deviceName;
		    return deviceReturn;
		}
		else
		{
			deviceReturn.num = 1003;
			deviceReturn.msg = "未找到任何key";
			return deviceReturn;
		}
	}
	//获取证书列表
	function getUserList(deviceName)
	{
	    var errorMsg = "error:";
		var ret = token.SOF_GetDeviceInstance(deviceName, "");

		if(ret != 0)
		{
		    return errorMsg + "实例化失败";
		} 
		var cerList = token.SOF_GetUserList();
		return "true";
		
	}
	
	//验证用户密码
	function verifyUserPin(userPwd)
	{
	    var errorMsg = "error:";
		var ret = 0;
		var strRes = "";

		var hwType = token.SOF_GetHardwareType();
		if(hwType == token.TYPE_FPKEY)
		{
		}
		else
		{
		    var pin = userPwd;
			ret = token.SOF_Login(pin);
			if(ret == 0)
			{
			    return "true";
			}
			else 
			{
			    return errorMsg + "安全码错误";
			}
		}
		
	}
	
	
	//控件版本信息
	 function getVersion()
    {
        var version = token.SOF_GetVersion();
		document.getElementById("contorlInfo").value = version;			
	 }

	 function getFiles() {
	     return token.SOF_EnumFiles();
	 }
	

	function ReadFileValue(fileName) {
	    var fileData = token.SOF_ReadFile(fileName, 0, 0);
	    return _Base64decode(fileData);

	}

export {
    addOption,
    enumDevice,
    getUserList,
    verifyUserPin,
    getVersion,
    getFiles,
    ReadFileValue,
}


// WEBPACK FOOTER //
// ./src/page/login/Ukey/mTokenBasicOper.js